import React from "react";
import { AdminPanel } from "../content/adminPanel";
import { CompaniesTable } from "../content/companies";
import { ReportsTable } from "../content/reports";

export type RouteType = {
  path: string;
  text: string;
  // eslint-disable-next-line no-unused-vars
  content: () => React.ReactNode;
};
export const paths: RouteType[] = [
  {
    path: "/",
    text: "Организация-услуга",
    content: AdminPanel,
  },
  {
    path: "/Companies",
    text: "Организации",
    content: CompaniesTable,
  },
  {
    path: "/Reports",
    text: "Отчёты",
    content: ReportsTable,
  },
];
